import reduceReducers from 'reduce-reducers'
import { makeApiTypes } from 'sidecar-utility-library'

import { default as PlanReducer } from './Plan'

export * from './Plan'

export const types = {
  ...makeApiTypes('FETCH_PLAN', 'plans'),
}

export const initialState = {
  plan: {
    busy: false,
    entity: {},
    error: null,
  },
}

export default reduceReducers(
  PlanReducer,
  // the last arg MUST be the shared state
  initialState,
)
